import * as React from "react";



export default class ConsumptionComparisonModal extends React.PureComponent {


  render() {
    
    return (
      <div
        className="modal fade"
        id="consumptionComparisonModal"
        role="dialog"
        aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
       
            <p className="subheading">Ett sätt att jämföra din elförbrukning</p>
            <p className="copy">Den normala förbrukningen och elkostnaden beror på många faktorer men en av de viktigaste är om du bor i lägenhet eller villa.</p> 
            
            <p className="subheading"> Vad är en normal förbrukning för en lägenhet</p>
            <p className="copy">En normal årlig energiförbrukning för en mindre lägenhet, som en etta eller en mindre tvåa är i genomsnitt 2000 kWh per år och för en större bostad är förbrukningen i genomsnitt 5000 kWh per år.</p> 
          
            <p className="subheading"> Vad är en normal förbrukning för en villa</p>
            <p className="copy">En genomsnittlig villa i Sverige förbrukar ungefär 20 000 kWh per år, men detta kan variera beroende på husets storlek, uppvärmningssystem och hushållets vanor. Om du har fjärrvärme eller värmer huset och vattnet på något annat sätt än med el är en normal årlig elförbrukning ca 5000 kWh.</p> 
            
            <p className="copy">Källa: <a href="https://www.energimarknadsbyran.se/el/dina-avtal-och-kostnader/elkostnader/elforbrukning/"> Konsumenternas Energimarknadsbyrå</a></p>
            
             
            <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Stäng
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
